<microempresario-header></microempresario-header>

<div class="home-v2">
  <app-home-bienvenida-banner [displayName]="name" [isJuridica]="isJuridica"></app-home-bienvenida-banner>

  <section class="home-v2__cta-bar" aria-label="Acciones del perfil">
    <div class="home-v2__cta-bar-inner">
      <div class="home-v2__cta-text">
        <p class="home-v2__cta-name">{{ fullName }}</p>
        <p class="home-v2__cta-subtitle">{{ copy.ctaBar.subtitle }}</p>
      </div>
      <button type="button" class="home-v2__cta-btn" id="btn-home-solicitar-credito" (click)="validarRestricciones()">
        {{ copy.ctaBar.solicitarCredito }}
      </button>
    </div>
  </section>

  <section class="home-v2__solicitudes" aria-labelledby="home-solicitudes-title">
    @if (idsolicitudDevuelta && observacionDevolucion) {
    <div id="observaciones" class="home-v2__table-card home-v2__obs-card">
      <div class="home-v2__obs">
        <label class="home-v2__obs-label" for="home-obs-devolucion">
          Aquí podrás observar el motivo de la devolución de tu solicitud "{{
            idsolicitudDevuelta
          }}"
        </label>
        <textarea id="home-obs-devolucion" rows="4" class="home-v2__obs-text" maxlength="3000"
          [value]="observacionDevolucion" disabled readonly></textarea>
      </div>
    </div>
    }

    <div class="home-v2__table-card">
      <div class="home-v2__solicitudes-head">
        <div class="home-v2__solicitudes-titles">
          <h2 id="home-solicitudes-title" class="home-v2__solicitudes-title">
            {{ copy.solicitudes.title }}
          </h2>
          <p class="home-v2__solicitudes-subtitle">{{ copy.solicitudes.subtitle }}</p>
        </div>

        <div class="home-v2__filtros" role="tablist" aria-label="Filtrar solicitudes">
          @for (filtro of filtros; track filtro.id) {
          <button type="button" class="home-v2__filtro" role="tab"
            [class.home-v2__filtro--active]="filtroActivo === filtro.id"
            [attr.aria-selected]="filtroActivo === filtro.id" [id]="'btn-home-filtro-' + filtro.id"
            (click)="setFiltro(filtro.id)">
            {{ filtro.label }}
          </button>
          }
        </div>
      </div>

      @if (solicitudesFiltradas.length === 0) {
      <p class="home-v2__empty">{{ copy.solicitudes.empty }}</p>
      } @else {
      <div class="home-v2__table-wrap d-none d-lg-block">
        <table class="home-v2__table">
          <thead>
            <tr>
              <th scope="col">{{ copy.solicitudes.columnas.solicitud }}</th>
              <th scope="col">{{ copy.solicitudes.columnas.monto }}</th>
              <th scope="col">{{ copy.solicitudes.columnas.fecha }}</th>
              <th scope="col">{{ copy.solicitudes.columnas.estado }}</th>
              <th scope="col">{{ copy.solicitudes.columnas.acciones }}</th>
            </tr>
          </thead>
          <tbody>
            @for (solicitud of solicitudesFiltradas; track solicitud.idSolicitud) {
            <tr>
              <td>
                <a class="home-v2__id-link"
                  [routerLink]="detalleSolicitudLink(solicitud)"
                  placement="top"
                  tooltipClass="stylesToll"
                  container="body"
                  [openDelay]="200"
                  [ngbTooltip]="copy.solicitudes.tooltipId"
                  [attr.aria-label]="copy.solicitudes.tooltipId + ': ' + solicitud.idSolicitud">
                  {{ solicitud.idSolicitud }}
                </a>
              </td>
              <td>
                @if (solicitud.monto != null) {
                {{ solicitud.monto | currency: 'COP':'symbol-narrow':'1.0-0' }}
                } @else {
                —
                }
              </td>
              <td>
                {{
                !solicitud.fechaCreacion
                ? '—'
                : (solicitud.fechaCreacion | date: 'dd/MM/yyyy':'en-CA')
                }}
              </td>
              <td>
                <span class="home-estado-badge" [ngClass]="estadoVisual(solicitud).badgeClass">
                  {{ estadoVisual(solicitud).label }}
                </span>
              </td>
              <td>
                <div class="home-v2__acciones">
                  @if (accionContextualLabel(solicitud); as accionCtx) {
                  <button
                    type="button"
                    class="home-v2__detalle"
                    [attr.id]="esCtaOfertas(solicitud) ? 'btn-home-revisar-ofertas' : null"
                    (click)="onAccionContextual(solicitud, $event)"
                  >
                    {{ accionCtx }}
                    <span class="material-icons" aria-hidden="true">chevron_right</span>
                  </button>
                  }
                  @if (puedeVerDetalle(solicitud)) {
                  <a class="home-v2__detalle" href="#" (click)="onVerDetalle(solicitud, $event)">
                    {{ copy.solicitudes.verDetalle }}
                    <span class="material-icons" aria-hidden="true">chevron_right</span>
                  </a>
                  }
                  @if (puedeCancelar(solicitud)) {
                  <button type="button" class="home-v2__trash" [attr.aria-label]="copy.solicitudes.eliminarAria"
                    placement="top" tooltipClass="stylesToll" container="body" [openDelay]="300"
                    [ngbTooltip]="copy.solicitudes.eliminarAria"
                    (click)="modalCerrarSolicitud(solicitud.idSolicitud)">
                    <span class="material-icons" aria-hidden="true">delete_outline</span>
                  </button>
                  }
                </div>
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>

      <div class="home-v2__cards d-lg-none">
        @for (solicitud of solicitudesFiltradas; track solicitud.idSolicitud; let i = $index) {
        <article class="home-v2__card">
          <div class="home-v2__card-header">
            <div class="home-v2__card-id-block">
              <span class="home-v2__card-label">{{ copy.solicitudes.columnas.solicitud }}</span>
              <a class="home-v2__id-link home-v2__id-link--card"
                [routerLink]="detalleSolicitudLink(solicitud)"
                placement="top"
                tooltipClass="stylesToll"
                container="body"
                [openDelay]="200"
                [ngbTooltip]="copy.solicitudes.tooltipId"
                [attr.aria-label]="copy.solicitudes.tooltipId + ': ' + solicitud.idSolicitud">
                {{ solicitud.idSolicitud }}
              </a>
            </div>
            <div class="home-v2__card-acciones">
              @if (accionContextualLabel(solicitud); as accionCtx) {
              <button
                type="button"
                class="home-v2__detalle home-v2__detalle--card"
                (click)="onAccionContextual(solicitud, $event)"
              >
                {{ accionCtx }}
                <span class="material-icons" aria-hidden="true">chevron_right</span>
              </button>
              }
              @if (puedeVerDetalle(solicitud)) {
              <a class="home-v2__detalle home-v2__detalle--card" href="#"
                (click)="onVerDetalle(solicitud, $event)">
                {{ copy.solicitudes.verDetalle }}
                <span class="material-icons" aria-hidden="true">chevron_right</span>
              </a>
              }
            </div>
          </div>

          <div class="home-v2__card-body">
            <div class="home-v2__card-values">
              <p class="home-v2__card-monto">
                @if (solicitud.monto != null) {
                {{ solicitud.monto | currency: 'COP':'symbol-narrow':'1.0-0' }}
                } @else {
                —
                }
              </p>
              <p class="home-v2__card-fecha">
                {{
                !solicitud.fechaCreacion
                ? '—'
                : (solicitud.fechaCreacion | date: 'dd/MM/yyyy':'en-CA')
                }}
              </p>
            </div>
            <div class="home-v2__card-status">
              <span class="home-estado-badge" [ngClass]="estadoVisual(solicitud).badgeClass">
                {{ estadoVisual(solicitud).label }}
              </span>
              @if (puedeCancelar(solicitud)) {
              <button type="button" class="home-v2__trash" [attr.aria-label]="copy.solicitudes.eliminarAria"
                placement="top" tooltipClass="stylesToll" container="body" [openDelay]="300"
                [ngbTooltip]="copy.solicitudes.eliminarAria"
                (click)="modalCerrarSolicitud(solicitud.idSolicitud)">
                <span class="material-icons" aria-hidden="true">delete_outline</span>
              </button>
              }
            </div>
          </div>
        </article>
        }
      </div>
      }
    </div>
  </section>

  <!-- Mobile: imagen PN/PJ al final, después de la tabla -->
  <div class="home-v2__portrait" [class.home-v2__portrait--juridica]="isJuridica" aria-hidden="true">
    <picture>
      <source media="(max-width: 767.98px)" [attr.srcset]="portraitSrcMobile" />
      <img class="home-v2__portrait-img" [src]="portraitSrc"
        [alt]="isJuridica ? 'Persona jurídica' : 'Persona natural'" />
    </picture>
  </div>

  <!-- Modales (misma lógica de negocio) -->
  <div class="modal fade" id="modalRestriccion" tabindex="-1" aria-labelledby="modalRestriccion">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title" style="color: #00e5be">¡Atención!</h2>
        </div>
        <h5 class="modal-body">{{ mensajeRestriccion }}</h5>
        <div class="modal-footer">
          <button type="button" class="btn" data-bs-dismiss="modal">Aceptar</button>
        </div>
      </div>
    </div>
  </div>

  <app-home-enviar-modal [open]="enviarModalOpen" [mensaje]="solicitudCompleta"
    [enviando]="enviandoSolicitud" (closed)="closeEnviarModal()" (revisar)="onEnviarRevisar()"
    (enviar)="onEnviarSolicitudV2()"></app-home-enviar-modal>

  <app-home-cancelar-modal [open]="cancelarModalOpen" [step]="cancelarModalStep"
    [idSolicitud]="numeroSolicitud" [mensajeConfirmacion]="mensaje"
    [confirmando]="confirmandoCancelacion" (closed)="closeCancelarModal()"
    (solicitarConfirmacion)="onCancelarSolicitarConfirmacion($event)"
    (confirmar)="onCancelarConfirmar()"></app-home-cancelar-modal>

  <app-home-info-modal [open]="infoModalOpen" [variant]="infoModalVariant"
    [finalizando]="finalizandoInfoModal" (closed)="closeInfoModal()"
    (finalizar)="finalizar()"></app-home-info-modal>

  <div class="modal fade text-center" id="aceptarModal" tabindex="-1" aria-labelledby="aceptarModalLabel"
    aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="aceptarModalLabel" style="color: white">
            ENVIAR SOLICITUD
          </h4>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body justify-content-md-center">
          <div class="row">
            <div class="col-12 col-sm-12">
              <h5 style="color: black">{{ mensajeEnvio }}</h5>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-md-center">
          <button type="button" class="btn btn-primary" (click)="saveSolicitud()">
            Enviar solicitud
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Burbujas Figma — solo desktop/tablet (mismo patrón que perfil-shell) -->
  <div class="home-v2__bubbles" aria-hidden="true">
    <span class="home-v2__bubble home-v2__bubble--lg"></span>
    <span class="home-v2__bubble home-v2__bubble--sm"></span>
  </div>
</div>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>

<div class="home-v2__chrome">
  <app-footer-public variant="compact"></app-footer-public>
  <app-home-site-footer></app-home-site-footer>
</div>